
import validators from "./validators"

export const chargeTypeSelect = {
    type: "select",
    options: [
        {value: '%',  display: '% one time'},
        {value: '$f', display: '$ one time'},
        {value: '%y', display: '% per year'},
        {value: '$y', display: '$ per year'},
    ]
}

export const flatFeeChargeTypeSelect = {
    type: "select",
    options: [
        {value: '%', display: '%'},
        {value: '$', display: '$'},
    ]
}


// the input component default prepends a {value: null, display: '--'} option
export const nullBooleanSelect = {
    type: "select",
    options: [
        {value: true, display: 'yes'},
        {value: false, display: 'no'},
    ]
}


export const loanFeeTypeSelect = {
    type: "select",
    options: [
        {value: "capitalized", display: "Capitalized Expense"},
        {value: "application", display: "Application"},
        {value: "closing", display: "Charged at closing"},
        {value: "payments", display: "Added to payments"},
        {value: 'kw', display: "Charged Annually based on System size in kW (PPA only, $ only)"},
    ],
    value: "capitalized"
}



// ids and names to prevent constant reloading. This will need to be updated.
export const loanProductTypeSelect = {
    type: "select",
    options: [
        {
            value: 4,
            display: "PACE"
        },
        {
            value: 6,
            display: "PPA"
        },
        {
            value: 7,
            display: "Capital Lease"
        },
        {
            value: 10,
            display: "Loan"
        },
        {
            value: 11,
            display: "Solar Power Agreement"
        }
    ]
}

export const loanResidentialProductTypeSelect = {
    type: "select",
    options: [
        {
            value: 4,
            display: "PACE"
        },
        {
            value: 6,
            display: "PPA"
        },
        {
            value: 7,
            display: "Capital Lease"
        },
        {
            value: 10,
            display: "Loan"
        },
        {
            value: 11,
            display: "Solar Power Agreement"
        }
    ]
}


export const userTypeSelect = {
    type: "select",
    options: [
        {
            value: 'owner',
            display: 'Property Owner'
        },
        {
            value: 'contractor',
            display: 'Contractor / Project Manager'
        },
        {
            value: 'renter',
            display: 'Property Renter'
        },
        {
            value: 'property_manager',
            display: 'Property Manager'
        },
        {
            value: 'neca_contractor',
            display: 'NECA Contractor'
        },
        {
            value: 'signatory_contractor_ibew',
            display: 'Signatory Contractor (IBEW)'
        },
        {
            value: 'other',
            display: 'Other'
        },
    ]
}



export const rateTypeSelect = {
    type: 'select',
    label: 'Rate Type',
    options: [
        {
            display: "¢ Per kWh",
            value: "per_kwh"
        },
        {
            display: "% Fixed",
            value: "fixed"
        },
        {
            display: "% + 5yr T-bill",
            value: "float_w_5yr"
        },
        {
            display: "% + 7yr T-bill",
            value: "float_w_7yr"
        },
        {
            display: "% + 10yr T-bill",
            value: "float_w_10yr"
        },
        {
            display: "% + 20yr T-bill",
            value: "float_w_20yr"
        },
        {
            display: "% + 30yr T-bill",
            value: "float_w_30yr"
        }
    ],
    dataKey: "rate_type",
}


export const slugInput = {
    type: "text",
    label: "Slug (DANGER!)",
    subLabel: "Used for to reference this object from api calls, and to regenerate the name in certain instances. Make sure it is a good reflection of the name. Must be lowercase a-z and hyphens only. IF YOU EDIT THIS VALUE FOR EXISTING OBJECTS, YOU MAY BREAK LOOKUPS ON OLD PROJECTS. DON'T DO IT UNLESS YOU ARE SURE.",
    dataKey: "slug",
    ...validators.isValidSlug
}